"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationTypeList = exports.NotificationType = void 0;
var NotificationType = {
  Information: 'information',
  Warning: 'warning',
  Error: 'error',
  Success: 'success'
};
exports.NotificationType = NotificationType;
var notificationTypeList = Object.keys(NotificationType).map(function (key) {
  return NotificationType[key].toLowerCase();
});
exports.notificationTypeList = notificationTypeList;